import { useNavigate } from 'react-router-dom';
import { AuthenticationBaseLayout } from '../../components/ui/authentication/authenticationBaseLayout';
import { Button } from '@/components/ui/button';

export const CheckEmail = () => {
  const navigate = useNavigate();

  const onReturnToSignIn = () => {
    navigate('/login');
  };

  return (
    <AuthenticationBaseLayout>
      <div className="flex flex-col items-start w-full max-w-sm p-6 lg:w-auto lg:max-w-none">
        <div className="flex flex-col justify-start items-start mb-4 text-left">
          <h1 className="text-base font-bold text-card-foreground">
            Check Your Email
          </h1>
          <p className="text-sm text-muted-foreground mt-2">
            We’ve sent a link to reset your password. It should <br />
            arrive in the next few minutes.
          </p>

          <Button onClick={onReturnToSignIn} className="mt-6">
            Return To Sign In
          </Button>
        </div>
      </div>
    </AuthenticationBaseLayout>
  );
};
